import { Form } from '@mairistem/composants';
import dayjs from 'dayjs';
import { formatMonetaire } from '@/utils';

interface VirementProps {
  numero: string;
  dateValidite: string;
  banque: string;
  tireur: string;
  montant: number;
}

const Virement = (props: VirementProps) => {
  const {
    numero: numeroProps,
    dateValidite: dateProps,
    banque: banqueProps,
    tireur: tireurProps,
    montant: montantProps,
  } = props;

  return (
    <Form.Group style={{ margin: 0, flex: 1 }}>
      <Form.Field inline width={2}>
        <label>Virement</label>
      </Form.Field>
      <Form.Field inline width={2}>
        N°
        {' : '}
        <label>{numeroProps}</label>
      </Form.Field>
      <Form.Field inline width={3}>
        Date
        {' : '}
        <label>{dayjs(dateProps).format('DD/MM/YYYY')}</label>
      </Form.Field>
      <Form.Field inline width={3}>
        Banque
        {' : '}
        <label>{banqueProps}</label>
      </Form.Field>
      <Form.Field inline width={4}>
        Tireur
        {' : '}
        <label>{tireurProps}</label>
      </Form.Field>
      <Form.Field
        inline
        width={2}
        // @ts-expect-error
        style={{ textAlign: 'right' }}
      >
        Montant
        {' : '}
        <label>{formatMonetaire(montantProps, 2)}</label>
      </Form.Field>
    </Form.Group>
  );
};

export default Virement;
